module.exports = __webpack_public_path__ + "img/categories.eaff98b0.svg";